import React from 'react'
import styled from 'styled-components'

import Footer from 'footer'

import HeaderMenu from './HeaderMenu'
import Messager from './Messager'

const MainLayout = (props) => {
  const { children } = props

  return (
    <Wrapper>
      <HeaderMenu />
      <Messager />
      <Body>{children}</Body>
      <Footer />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  height: 100%;
  align-items: center;
`

const Body = styled.div`
  width: 100%;
  min-height: 90vh;
  max-width: 1440px;
  margin-top: 70px;

  @media print {
    min-height: 90vh;
    margin-top: 0px;
    padding: 0px;
  }
`

export default MainLayout
